<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-pro-check-in-out") {
            next({ name: "relatorio-pro-check-in-out-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-pro-check-in-out") {
            this.$router.push({ name: "relatorio-pro-check-in-out-list" });
        }
    },
};
</script>